import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contex/AuthContext";
import { updateUserProfile } from "../lib/db";

export default function OnboardingScreen() {
  const { profile, setProfile } = useAuth();
  const navigate = useNavigate();
  const [school, setSchool] = useState("");
  const [programme, setProgramme] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    try {
      await updateUserProfile({ school, programme });
      setProfile(p => ({ ...p, school, programme }));
      navigate("/");
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleSkip = () => navigate("/");

  return (
    <div style={styles.wrap}>
      <div style={styles.logo}>Study<span style={{color:"#7C6EF8"}}>OS</span></div>
      <div style={styles.welcome}>
        Welcome, {profile?.name || "Student"} 👋
      </div>
      <div style={styles.sub}>
        Tell us about your studies so we can personalise your experience.
      </div>

      <div style={styles.form}>
        <div style={styles.group}>
          <label style={styles.label}>School / University</label>
          <input style={styles.input} type="text"
            placeholder="e.g. University of Ghana"
            value={school} onChange={e => setSchool(e.target.value)} />
        </div>
        <div style={styles.group}>
          <label style={styles.label}>Programme / Course of study</label>
          <input style={styles.input} type="text"
            placeholder="e.g. BSc Economics"
            value={programme} onChange={e => setProgramme(e.target.value)} />
        </div>

        <button style={styles.primaryBtn} onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Get started →"}
        </button>

        <button style={styles.skipBtn} onClick={handleSkip}>
          Skip for now
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap:       { minHeight:"100vh", background:"#0F0F13", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" },
  logo:       { fontSize:"28px", fontWeight:700, color:"#F0EFE8", letterSpacing:"-1px", marginBottom:"16px" },
  welcome:    { fontSize:"24px", fontWeight:700, color:"#F0EFE8", marginBottom:"8px", textAlign:"center" },
  sub:        { fontSize:"14px", color:"#9998A0", marginBottom:"40px", textAlign:"center", lineHeight:1.6 },
  form:       { width:"100%", maxWidth:"360px" },
  group:      { marginBottom:"16px" },
  label:      { display:"block", fontSize:"12px", fontWeight:600, color:"#9998A0", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"6px" },
  input:      { width:"100%", padding:"14px 16px", background:"#18181F", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", color:"#F0EFE8", outline:"none" },
  primaryBtn: { width:"100%", padding:"15px", background:"#7C6EF8", border:"none", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"12px" },
  skipBtn:    { width:"100%", padding:"14px", background:"transparent", border:"none", fontFamily:"inherit", fontSize:"14px", color:"#9998A0", cursor:"pointer" },
};